module.exports = __webpack_public_path__ + "static/media/back-5.3cc221b5.svg";